import * as React from 'react'
import {ReactElement} from 'react'
import {NatApplicationRepo} from '../repository/NatApplicationRepo'
import {Nullable} from '../../../../app/TypeHelpers'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {DisplayItemDividerForPageTop} from '../../../../styledComponents/DisplayItem'
import {
    CenterPlainLinkStyledButton,
    PlainLinkStyledBackButton,
    PrimaryStyledButton,
} from '../../../../styledComponents/Button'
import {Box} from '@mui/material'
import {PageTitle} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {NatLongAbsenceInfo, NatResidentLongAbsenceLocationState} from './NatResidentApplicationInterface'
import {NatPutLongAbsenceRequest, NatPutLongAbsenceResponse} from '../repository/NatPutLongAbsence'
import NatResidentLongAbsenceConfirm from './resident/NatResidentLongAbsenceConfirm'
import {Location} from 'react-router-dom'

interface Props {
    applicationRepo: NatApplicationRepo
    condominiumCd: string
    location: Location<NatResidentLongAbsenceLocationState>
}

class NatResidentLongAbsenceConfirmPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.handleRegisterButtonClick = this.handleRegisterButtonClick.bind(this)
        this.handleBackLinkOnClick = this.handleBackLinkOnClick.bind(this)
    }

    async handleRegisterButtonClick(): Promise<void> {
        await this.props.eventEmitter.showLoading()
        const {applicationRepo, condominiumCd} = this.props
        const locationState: NatLongAbsenceInfo = this.props.location.state.applyInfo
        const {
            applicantFamilyName,
            applicantFirstName,
            absenceStartDate,
            absenceEndDate,
            applicantContactPhoneNumber,
            destinationType,
            destinationZipCode,
            destinationPrefecture,
            destinationAddress2,
            destinationAddress3,
            destinationBuildingRoomNumber,
            destinationAddress,
            contactFamilyName,
            contactFirstName,
            contactRelationship,
            contactZipCode,
            contactPrefecture,
            contactAddress2,
            contactAddress3,
            contactBuildingRoomNumber,
            contactPhoneNumber,
        } = locationState

        const request: NatPutLongAbsenceRequest = {
            applicantFamilyName: applicantFamilyName,
            applicantFirstName: applicantFirstName,
            absenceStartDate: absenceStartDate,
            absenceEndDate: absenceEndDate,
            applicantContactPhoneNumber: applicantContactPhoneNumber,
            destinationType: destinationType,
            destinationZipCode: destinationZipCode,
            destinationPrefecture: destinationPrefecture,
            destinationAddress2: destinationAddress2,
            destinationAddress3: destinationAddress3,
            destinationBuildingRoomNumber: destinationBuildingRoomNumber,
            destinationAddress: destinationAddress,
            contactFamilyName: contactFamilyName,
            contactFirstName: contactFirstName,
            contactRelationship: contactRelationship,
            contactZipCode: contactZipCode,
            contactPrefecture: contactPrefecture,
            contactAddress2: contactAddress2,
            contactAddress3: contactAddress3,
            contactBuildingRoomNumber: contactBuildingRoomNumber,
            contactPhoneNumber: contactPhoneNumber,
            confirmed: true,
        }

        if (!request) {
            return
        }

        try {
            const response: Nullable<NatPutLongAbsenceResponse> = await this.props.asyncCallFunction(
                applicationRepo.applyLongAbsence.bind(
                    applicationRepo, condominiumCd, request),
                () => {
                    this.props.navigate(`/resident/error`, {replace: true})
                },
            )
            if (response && response.requestError === null) {
                this.props.navigate(
                    `/resident/condominiums/${this.props.condominiumCd}/applications/complete`,
                    {replace: true},
                )
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    handleBackLinkOnClick(): void {
        const locationState: NatResidentLongAbsenceLocationState = this.props.location.state
        this.props.navigate(
            this.props.location.state.applyId
                ? `/resident/condominiums/${this.props.condominiumCd}/applications/longAbsence/${this.props.location.state.applyId}/copy`
                : `/resident/condominiums/${this.props.condominiumCd}/applications/longAbsence/input`,
            {
                replace: true,
                state: JSON.parse(JSON.stringify(locationState)),
            },
        )
    }

    render(): ReactElement {
        return (
            <>
                <PlainLinkStyledBackButton onClick={this.handleBackLinkOnClick}>戻る</PlainLinkStyledBackButton>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    申請内容確認
                </PageTitle>
                <Box height={'20px'}/>
                <NatResidentLongAbsenceConfirm
                    {...this.props.location.state.applyInfo}
                />
                <BlockSpacer height={'30px'}/>
                <PrimaryStyledButton onClick={this.handleRegisterButtonClick}>
                    申請を提出する
                </PrimaryStyledButton>
                <BlockSpacer height={'20px'}/>
                <CenterPlainLinkStyledButton onClick={this.handleBackLinkOnClick}>
                    修正する
                </CenterPlainLinkStyledButton>
                <BlockSpacer height={'15px'}/>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentLongAbsenceConfirmPage)
